import React from 'react'
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Button,
  Row,
  Col,
} from 'reactstrap'

const getStatusLabel = (status) => {
  switch (status) {
    case 'ACTIVE':
      return 'Activo'
    case 'BLOCKED':
      return 'Bloqueado'
    case 'DELETED':
      return 'Eliminado'
    default:
      return 'Desconocido'
  }
}

const getStatusBadgeClass = (status) =>
  status === 'ACTIVE' ? 'badge-active' : 'badge-blocked'

const buildUrl = (url) => {
  if (!url) return null
  return /^https?:\/\//i.test(url) ? url : `http://${url}`
}

function InstanceCard({ item, onEdit, onToggleBlock, onDelete }) {
  const statusLabel = getStatusLabel(item.status)
  const badgeClass = getStatusBadgeClass(item.status)
  const href = buildUrl(item.url)

  return (
    <Card className="instance-card">
      <CardHeader>
        <Row>
          <Col>
            <h5 className="card-title mt-2">{item.name}</h5>
          </Col>
          <Col xs="auto">
            <span className={`badge ms-2 ${badgeClass}`}>{statusLabel}</span>
          </Col>
        </Row>
      </CardHeader>
      <CardBody>
        <p className="card-text">
          <strong>Url:</strong>
          {href ? (
            <a href={href} target="_blank" rel="noopener noreferrer"> {item.url}</a>
          ) : (
            ' -'
          )}
        </p>
        <p className="card-text">
          <strong>Nombre fiscal:</strong> {item.fiscalName || '-'}
        </p>
        {item.distributorName ? (
          <p className="card-text">
            <strong>Distribuidor:</strong> {item.distributorName}
          </p>
        ) : null}
      </CardBody>
      <CardFooter className="d-flex gap-2">
        <Button className="btn-card-primary" size="sm" onClick={() => onEdit(item.id)}>
          Editar
        </Button>
        <Button
          className={item.status === 'ACTIVE' ? 'btn-card-warning' : 'btn-card-success'}
          size="sm"
          onClick={() => onToggleBlock(item.id, item.status)}
        >
          {item.status === 'ACTIVE' ? 'Bloquear' : 'Desbloquear'}
        </Button>

      </CardFooter>
    </Card>
  )
}

export default InstanceCard
